import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {ANALYSIS_TOOL_SPACING} from 'analysis-tool/AnalysisToolConstants';
import {
  ParameterOptimizationPredictionRequestData,
  ParameterOptimizationPredictionResponse,
} from 'machine-learning/MachineLearningDAO';
import InlineBanner, {InlineBannerType} from 'ui-library/banners/InlineBanner';
import {GRAY_LIGHT, WHITE} from 'ui-library/Colors';
import {Header1} from 'ui-library/Headers';
import {AsyncState, AsyncStatus} from 'ui-library/hooks/useAsyncState';
import HorizontalThrobber from 'ui-library/HorizontalThrobber';

interface PredictionOutputProps {
  output: AsyncState<ParameterOptimizationPredictionResponse, [ParameterOptimizationPredictionRequestData]>;
}

export default function PredictionOutput({output}: PredictionOutputProps): JSX.Element {
  return (
    <div className={css(styles.container)}>
      <Header1>Predicted output</Header1>
      <p>Based on the parameter values you entered, we predict the experimental output to be:</p>
      {output.status === AsyncStatus.NOT_FETCHED && (
        <InlineBanner bannerType={InlineBannerType.INFO} hideIcon={true} text="--" />
      )}
      {output.status === AsyncStatus.LOADING && <HorizontalThrobber />}
      {output.status === AsyncStatus.ERROR && (
        <InlineBanner bannerType={InlineBannerType.ERROR} text={output.message} />
      )}
      {output.status === AsyncStatus.SUCCESS && (
        <InlineBanner bannerType={InlineBannerType.INFO} hideIcon={true} text={`${output.data.value}`} />
      )}
    </div>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: WHITE,
    borderRadius: 4,
    border: `1px solid ${GRAY_LIGHT}`,
    padding: ANALYSIS_TOOL_SPACING,
    margin: ANALYSIS_TOOL_SPACING,
  },
});
